<ng-container *transloco="let t">
  <pxc-top-bar [config]="topBarConfig" />

  <ng-template #headerTemplate let-entity>
    <pxc-sadm-grid-header-cell [entity]="entity" [sadmType]="sadmClient.sadmType" />
  </ng-template>

  <ng-template #arucoItem let-item let-source="source">
    @if (item.type === 'file') {
      <pxc-picture-aruco [source]="source" />
    } @else {
      <pxc-sequence-media class="block size-full" [media]="item.media" [showStickerStatus]="true" />
    }
  </ng-template>

  <ng-template #analysisProjection let-entity let-mode="mode">
    @let media = woundMedia(entity);
    <div class="relative p-2">
      <pxc-image-input
        ngDefaultControl
        size="large"
        uploadMode="custom"
        [medias]="media.medias()"
        [ngModel]="media.files()"
        [readOnly]="mode === 'readonly'"
        (addClicked)="openPicker(entity)"
        (mediaClickedIdx)="openGallery(entity, $event)"
        (mediaDelete)="onMediaDelete(entity.entityKey, $event)"
        (ngModelChange)="onFilesChange(entity.entityKey, $event)" />
      @if (mode !== 'readonly' && isMediaRequiredError(entity.entityKey)) {
        <pxc-error-icon class="absolute top-0 right-0" [message]="t('Au moins une photo est requise')" />
      }
    </div>
  </ng-template>

  <pxc-saving-notification />

  @let config = gridConfig();
  @if (config) {
    <tui-scrollbar class="flex-1 min-h-0 overflow-auto bg-background-primary-alt!">
      <div class="flex items-start">
        <pxc-form-grid [config]="config" />

        <div class="sticky top-0 p-5">
          <button
            appearance="outline"
            class="shadow-sm!"
            data-testid="add-entity-button"
            iconStart="@tui.plus"
            size="s"
            tuiButton
            type="button"
            (click)="addDraft()">
            {{ t('Ajouter une lésion') }}
          </button>
        </div>
      </div>
    </tui-scrollbar>
  } @else {
    <pxc-loader class="mx-auto my-4 block" data-testid="grid-loading">
      {{ t('Chargement de la lésion ...') }}
    </pxc-loader>
  }
</ng-container>
